// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"style_conteiner__31ZVb","card":"style_card__2d9uP","img":"style_img__27y6L","name":"style_name__2-cEG","types":"style_types__1FsE7"};